import Super from './ghost.gjs';

export default class SpdsActionButtonLink extends Super {
  classesToMapToAttrs = ['link'];
  link = true;
}
